import React, { useState } from 'react';
import { FiUpload } from 'react-icons/fi';

function UploadPaymentProof({ setPaymentProofFile }) {
  const [files, setFiles] = useState([]);

  const handleDrop = (e) => {
    e.preventDefault();
    const droppedFiles = Array.from(e.dataTransfer?.files || []);
    setFiles((prevFiles) => [...(prevFiles || []), ...droppedFiles]);
    setPaymentProofFile((prevFiles) => [...(prevFiles || []), ...droppedFiles]);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
  };

  const handleFile = (e) => {
    const selectedFiles = Array.from(e.target?.files || []);
    setFiles((prevFiles) => [...(prevFiles || []), ...selectedFiles]);
    setPaymentProofFile((prevFiles) => [...(prevFiles || []), ...selectedFiles]);
  };

  return (
    <div className='rounded-lg space-y-4'>
      <div
        onDrop={handleDrop}
        onDragOver={handleDragOver}
        className='flex flex-col text-b-mc p-6 text-center border-dashed border-t-bk border-hf'
        style={{ cursor: 'pointer' }}
      >
        <h3 className='flex flex-row gap-2 items-center justify-center'>
          <span>
            <FiUpload />
          </span>
          Drag & Drop Files Here
        </h3>
        {files.length > 0 && files.map((file, index) => (
          <p key={index}>Uploaded File: {file.name}</p>
        ))}
      </div>
      <div className='flex flex-col gap-2'>
        <input
          type='file'
          name='images'
          onChange={handleFile}
          className='w-full'
          style={{ display: 'none' }}
          id='file-upload'
          multiple
        />
        <label htmlFor='file-upload' className='cursor-pointer flex flex-col gap-2'>
          <span className='flex justify-center items-center bg-gray-200 p-2 rounded'>
            <FiUpload />
            &nbsp;Click to select files
          </span>
        </label>
      </div>
      {files.length > 0 && files.map((file, index) => (
        <img
          key={index}
          src={URL.createObjectURL(file)}
          alt={file.name}
          width={32}
          style={{ margin: '5px' }}
        />
      ))}
    </div>
  );
}

export default UploadPaymentProof;
